import angular from 'angular';
import i18n from '../i18n';
import angularBootstrapNpm from 'angular-ui-bootstrap';
import timepickerDirective from './time-picker-directive';
import timepickerDecorator from './timepicker-decorator';
/**
 * @ngdoc module
 * @deprecated akamai.components.time
 * @name akamai.components.time-picker
 *
 * @guideline https://design.akamai.com/components/time-picker/
 *
 * @description
 * Time selector is an interactive component that allows users to select a time from
 * an interactive dropdown menu. User can select the hour, minute and time of day.
 * The hour and minute controls are configurable and can be displayed in set intervals.
 * This is best used as a form control.
 *
 * @example index.html
 * <akam-time-picker
 *   ng-model="..."
 *   minute-step="..."
 *   hour-step="..."
 *   is-disabled="..."
 *   show-meridian="...">
 </akam-time-picker>
 *
 */
export default angular.module('akamai.components.time-picker', [
  angularBootstrapNpm,
  i18n.name
])

  // decorator for incepting Angular UI time picker to use our custom template
  .config(timepickerDecorator)

/**
 * @ngdoc directive
 * @name akamTimePicker
 * @restrict E
 *
 * @description Creates a time picker control.
 *
 * @param {string} ngModel - the time value.
 *
 * @param {boolean} [showMeridian=true] Whether to display 12H or 24H mode.
 *
 * @param {boolean} [is-disabled=false] If disabled, no user interaction will be possible.
 *
 * @param {boolean} [is-readonly=false] If readonly, no user interaction will be possible but the
 * text will be easier to read.
 *
 * @param {number} [hourStep=1] The value used to increment/decrement the hour value.
 *
 * @param {number} [minuteStep=15] The value used to increment/decrement the minute value.
 *
 * @param {string} timezone - the timezone in which the time should be displayed
 */
  .directive('akamTimePicker', timepickerDirective);